import {
	emailGetEmailThread,
	EmailGetEmailThreadProps
} from '@/modules/email/emailActions';
import { useDispatch } from 'react-redux';

export const useGetEmailQuery = () => {
	const dispatch = useDispatch();

	const mutate = (props: EmailGetEmailThreadProps) => {
		dispatch(emailGetEmailThread(props));
	};

	return { mutate };
};
